import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../services/account/account.service';
import { searchList } from '../../../../../utils';
import { CapitanLocation } from '../../../../../models/location';
import { LocationService } from '../../../../../services/location/location.service';


@Component({
  selector: 'app-select-location-modal',
  templateUrl: './select-location-modal.component.html',
  styleUrls: ['./select-location-modal.component.css']
})
export class SelectLocationModalComponent implements OnInit {

  @Input() excludeIds: number[];
  @Input() submitCallback: (location: CapitanLocation) => undefined;

  public loadingLocations = false;
  public searchInput = '';

  public locations: CapitanLocation[];
  public selectedLocation: CapitanLocation = null;

  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private locationService: LocationService,
    private accountService: AccountService
  ) {}

  ngOnInit() {
    this.loadLocations();
  }

  public filteredLocations(): CapitanLocation[] {
    return searchList<CapitanLocation>(
      this.searchInput,
      this.locations
        .filter(loc => !this.excludeIds.includes(loc.id))
        .map(loc => {
          return {
            value: loc,
            searchableText: loc.name
          };
        })
    );
  }

  public handleSearchInputChange() {
    this.selectedLocation = null;
  }

  public selectLocation(loc: CapitanLocation) {
    this.selectedLocation = loc;
    this.searchInput = loc.name;
  }

  public validInputSelected() {
    return this.selectedLocation !== null;
  }

  public handleSave() {
    this.submitCallback(this.selectedLocation);
    this.activeModal.close();
  }

  private loadLocations() {
    this.loadingLocations = true;

    this.locations = this.locationService.getLocations();

    if (this.locations !== null) {
      this.loadingLocations = false;
      return;
    }

    this.locationService
      .loadLocations()
      .then(() => {
        this.locations = this.locationService.getLocations();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingLocations = false; });
  }
}
